// extracted by mini-css-extract-plugin
module.exports = {"Search_Pill_Section":"SearchPillSection_Search_Pill_Section__3O76k"};